import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true,
  typographer: true,
})

type ContentType = string | { text: string } | undefined;

export const renderStaticContent = (content: ContentType): string => {
  if (typeof content === 'string') {
    if (content.trim().startsWith('<')) {
      return content;
    } else {
      // Preserve multiple consecutive line breaks
      const formattedContent = content
        .replace(/\n{2,}/g, match => '\n\n' + '&nbsp;'.repeat(match.length - 2) + '\n\n')
        // Preserve single line breaks
        .replace(/(?<!\n)\n(?!\n)/g, '  \n');
      
      return md.render(formattedContent);
    }
  } else if (content && typeof content === 'object' && 'text' in content) {
    return content.text;
  }
  return '';
};